"use strict";

/**
 * Toggles display of single code textareas for repeater fields
 */
(function ($) {
  'use strict';

  var settings;
  var $el;
  $(window).on('elementor/frontend/init', function () {
    if (window.elementor) {
      elementor.hooks.addAction('panel/open_editor/widget', function (panel, model, view) {
        if (model.attributes.widgetType === "ap-program-cards") {
          settings = view.getEditModel().get('settings');
          $el = panel.$el;
          $el.off('change', 'input[data-setting="use_same_description"]', onInputChange);
          $el.on('change', 'input[data-setting="use_same_description"]', onInputChange);
          $el.off('click', '.elementor-control-program_cards_list .elementor-repeater-add', onAddItemClick);
          $el.on('click', '.elementor-control-program_cards_list .elementor-repeater-add', onAddItemClick);
        }
      });
    }
  });
  function onInputChange(e) {
    var isChecked = $(e.currentTarget).is(':checked');
    checkRepeaterItems(isChecked);
  }
  function onAddItemClick(e) {
    var isChecked = $el.find('input[data-setting="use_same_description"]').is(':checked');
    checkRepeaterItems(isChecked);
  }
  function checkRepeaterItems(isChecked) {
    var control = settings.controls.program_cards_list;
    $.each(settings.attributes.program_cards_list.models, function (i, model) {
      model.set('use_global_description', isChecked ? 'yes' : 'no');
    });
  }
})(jQuery);
jQuery(document).ready(function ($) {
  function formatCurrency(amount) {
    amount = Math.round(amount);
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }
  $.fn.digits = function () {
    return this.each(function () {
      $(this).text($(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
  };
  var transfer_credits_slider = $("#transfer_credits_slider");
  var transfer_credits_slider_range_min = $("#transfer_credits_slider_range_min").val();
  var transfer_credits_slider_range_max = $("#transfer_credits_slider_range_max").val();
  var transfer_credits_slider_value = $("#transfer_credits_slider_range_value").val();
  var total_credit_hours = parseFloat($("#total_credit_hours").val()) || 0;
  var credit_hour_price = parseFloat($("#credit_hour_price").val()) || 0;
  var full_tuition_price = total_credit_hours * credit_hour_price;
  if ($(transfer_credits_slider).length) {
    $(document).ready(function () {
      $(transfer_credits_slider).attr('min', transfer_credits_slider_range_min);
      $(transfer_credits_slider).attr('max', transfer_credits_slider_range_max);
      $(transfer_credits_slider).val(transfer_credits_slider_range_value);
      $('.output_label.transfer_credits_slider_range_min').html(transfer_credits_slider_range_min);
      $('.output_label.transfer_credits_slider_range_max').html(transfer_credits_slider_range_max);
      $('#ch_output_value').html(transfer_credits_slider_value);
      $('#ch_output_value_text').val(transfer_credits_slider_value);
      $('#ch_output_value_text').attr('min', transfer_credits_slider_range_min);
      $('#ch_output_value_text').attr('max', transfer_credits_slider_range_max);
      var discounted = full_tuition_price - transfer_credits_slider_value * credit_hour_price;
      $('#discounted_tuition_output_value').html(formatCurrency(discounted));
      $('.clear_slider').click(function () {
        $(transfer_credits_slider).val(transfer_credits_slider_range_min);
        $('#ch_output_value').html(transfer_credits_slider_range_min);
        $('#ch_output_value_text').val(transfer_credits_slider_range_min);
        $('#discounted_tuition_output_value').html(formatCurrency(full_tuition_price));
      });
    });
    $(transfer_credits_slider).on('input change', function () {
      var v = $("#transfer_credits_slider").val();
      $('#ch_output_value').html(v);
      $('#ch_output_value_text').val(v);
      var discounted = full_tuition_price - v * credit_hour_price;
      $('#discounted_tuition_output_value').html(formatCurrency(discounted));
    });
    $(ch_output_value_text).on('input change', function () {
      var v = $('#ch_output_value_text').val();
      $(transfer_credits_slider).val(v);
      $('#ch_output_value').html(v);
      var discounted = full_tuition_price - v * credit_hour_price;
      $('#discounted_tuition_output_value').html(formatCurrency(discounted));
      var max = parseInt($(this).attr('max'));
      var min = parseInt($(this).attr('min'));
      if (v > max) {
        $(this).val(max);
        discounted = full_tuition_price - max * credit_hour_price;
        $('#discounted_tuition_output_value').html(formatCurrency(discounted));
      } else if (v < min) {
        $(this).val(min);
        $('#discounted_tuition_output_value').html(formatCurrency(full_tuition_price));
      }
    });
  }
});
(function ($) {
  function getVal($slider, $num) {
    var v = $slider.val();
    if (v == null || v === '') v = $num.val();
    return parseInt(v, 10) || 0;
  }
  function setClearState($a, val) {
    var disabled = val === 0;
    $a.attr('aria-disabled', disabled ? 'true' : 'false');

    // Keep out of tab order when disabled; focusable when enabled
    if (disabled) $a.attr('tabindex', '-1');else $a.attr('tabindex', '0');
    $a.toggleClass('is-disabled', disabled);
  }
  function isDisabled($a) {
    return $a.attr('aria-disabled') === 'true';
  }
  $(function () {
    var $wrap = $('.output.slidecontainer');
    var $slider = $wrap.find('#transfer_credits_slider');
    var $num = $('#ch_output_value_text');
    var $clear = $wrap.find('a.clear_slider');
    function refresh() {
      setClearState($clear, getVal($slider, $num));
    }
    $slider.on('input change', refresh);
    $num.on('input change', function () {
      $slider.val(this.value).trigger('input');
      refresh();
    });

    // NVDA Enter/Space typically triggers click on focused link gate on click
    $(document).on('click', 'a.clear_slider', function (e) {
      var $a = $(this);
      if (isDisabled($a)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      // enabled: perform clear action
      e.preventDefault();
      $slider.val(0).trigger('input');
      $num.val(0).trigger('change');
      refresh();
    });

    // Make Space activate consistently for non-NVDA/browser cases
    $(document).on('keydown', 'a.clear_slider', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var $a = $(this);
      if (isDisabled($a)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      e.preventDefault();
      $a.trigger('click');
    });
    refresh();
  });
})(jQuery);
(function ($) {
  'use strict';

  $(window).on('elementor/frontend/init', function () {
    var interval = setInterval(function () {
      if (elementorFrontend.elementsHandler) {
        clearInterval(interval);

        // Get default toggle widget handlers.
        var toggleHandler = elementorFrontend.elementsHandler.getHandler('toggle.default');

        // Register handlers for custom widget.
        elementorFrontend.hooks.addAction('frontend/element_ready/cf-courses-accordion.default', toggleHandler);
      }
    }, 50);
  });
})(jQuery);
(function ($) {
  'use strict';

  /**
   * If the target MUST be HIDDEN at runtime, please set it the CSS Class: `cf-toggle-target-hide`.
   *
   * @package cf-elementor-posts
   */
  function init($el) {
    var $expandItem = $el.find('.cf-expand-item');
    var $collapseItem = $el.find('.cf-collapse-item');
    var targetCSSId = $el.attr('data-target-css-id');
    var targetCSSClass = $el.attr('data-target-css-class');
    var targetSelector = "";

    // Find the target selector based on the CSS ID and CSS Class
    if (targetCSSId) {
      targetSelector = "#".concat(targetCSSId);
    } else if (targetCSSClass) {
      targetSelector += "[class*=".concat(targetCSSClass, "]");
    }
    var opened = $expandItem.css('display') === 'none';
    var $target = $(targetSelector);
    $target.css('display', $expandItem.css('display') !== 'none' ? 'none' : 'block');
    $el.on('click', function (e) {
      e.preventDefault();
      $target.stop().slideToggle();
      if (opened) {
        $expandItem.show();
        $collapseItem.hide();
      } else {
        $expandItem.hide();
        $collapseItem.show();
      }
      opened = !opened;
      return;
    });
  }

  // Elementor JS Hooks.
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cf-toggle-section.default', init);
  });
})(jQuery);
(function ($) {
  'use strict';

  //hide all levels 
  $(document).ready(function () {
    $('.next-path').hide();
  });

  //level 2 - non program
  $(document).on('click', '.main-path a.answer', function (e) {
    event.preventDefault();
    $('.main-path').hide();
    //get the id of the href clicked to show the correct div
    var mainelement = $(this).attr('id');
    $('#degree_path_' + mainelement).show();
  });

  //show program card 
  $(document).on('click', 'a.show-program', function (e) {
    event.preventDefault();
    $('.main-path').hide();
    $('.next-path').hide();
    var mainelement = $(this).attr('id');
    $('#degree_path_' + mainelement + '_program').show();
  });

  //level 3 & 4 - non program
  $(document).on('click', '.next-path a.answer', function (e) {
    event.preventDefault();
    var path_clicked = jQuery(this).parent().attr('id');
    $('#' + path_clicked).hide();
    $('.main-path').hide();
    $('.next-path').hide();
    //get the name of the thing clicked to show the div
    var mainelement = $(this).attr('id');
    $('#degree_path_' + mainelement).show();
  });

  //back to main 
  $(document).on('click', '.back-main', function (e) {
    event.preventDefault();
    $('.main-path').show();
    $('.next-path').hide();
  });
})(jQuery);
(function ($) {
  'use strict';

  function init() {
    var $expandItem = $('body').find('.cf-buttons-expand-item');
    var $collapseItem = $('body').find('.cf-buttons-collapse-item');
    $('body').on('click', '.cf-buttons-expand-item', onButtonClick);
    $('body').on('click', '.cf-buttons-collapse-item', onButtonClick);
  }
  function onButtonClick(e) {
    e.preventDefault();
    var $el = $(e.currentTarget);
    var $container = $el.closest('.elementor-widget-container');
    var $expandItems = $container.find('.cf-buttons-expand-item');
    var $collapseItems = $container.find('.cf-buttons-collapse-item');
    var opened = $expandItems[0].style.display === 'none';
    var $targetTitleItems = $container.find('.elementor-toggle .elementor-toggle-item .elementor-tab-title');
    var $targetContentItems = $container.find('.elementor-toggle .elementor-toggle-item .elementor-tab-content');
    if (opened) {
      $expandItems.show();
      $collapseItems.hide();
      $targetTitleItems.removeClass('elementor-active');
      $targetContentItems.removeClass('elementor-active');
      $targetContentItems.stop().slideUp();
    } else {
      $expandItems.hide();
      $collapseItems.show();
      $targetTitleItems.addClass('elementor-active');
      $targetContentItems.addClass('elementor-active');
      $targetContentItems.stop().slideDown();
    }
    return;
  }
  $(document).ready(function () {
    init();
  });
})(jQuery);
(function ($) {
  'use strict';

  $(window).on('elementor/frontend/init', function () {
    var isFaq = $('.elementor-widget-cf-faq').length > 0;
    var interval = setInterval(function () {
      if (elementorFrontend.elementsHandler) {
        clearInterval(interval);

        // Get default toggle widget handlers.
        var toggleHandler = elementorFrontend.elementsHandler.getHandler('toggle.default');

        // Register handlers for custom widget.
        elementorFrontend.hooks.addAction('frontend/element_ready/cf-faq.default', toggleHandler);
      }
      if (isFaq) {
        var url = window.location.hash;
        var idx = url.indexOf('#');
        var hash = idx != -1 ? url.substring(idx + 1) : '';
        if (hash) {
          var $target = $("#".concat(hash));
          var sticky = $('.elementor-sticky');
          if (sticky.length > 0) {
            var offset = sticky.outerHeight() + sticky.position().top;
            $('html, body').animate({
              scrollTop: $target.offset().top - offset
            }, 1000);
          }
          $target.find('a').first().trigger('click');
        }
      }
    }, 50);
  });
})(jQuery);
(function ($) {
  'use strict';

  jQuery(document).ready(function () {
    // Add 'mouseover' actions only for tablet and desktop resolutions.
    $('body').on('mouseover', '.max-mega-menu .mega-menu-item > .mega-sub-menu .mega-menu-link', function () {
      if ($('body').attr('data-elementor-device-mode') === 'mobile') {
        return;
      }
      var $submenu = $(this).next('.mega-sub-menu');

      // Set the currentTarget '.mega-sub-menu' as active.
      if ($submenu.length > 0) {
        $(this).closest('.mega-sub-menu').find('.mega-menu-item').removeClass('mega-toggle-on');
        $(this).parent().addClass('mega-toggle-on');
      }
    });

    // Add 'mouseleave' actions to all '.mega-sub-menu' items, and close the maga-menu navigation.
    $('body').on('mouseleave', '.max-mega-menu > .mega-menu-item > .mega-sub-menu', function () {
      if ($('body').attr('data-elementor-device-mode') === 'mobile') {
        return;
      }
      $('body').click();
    });

    // Add 'click' actions to all '.mega-menu-link' items to avoid double clicking before redirecting to the new URL.
    //WE REMOVED THIS SO THAT WE CAN HAVE AN EXTERNAL LINK IN THE NAVIGATION 
    /* $('body').on('click', '.max-mega-menu .mega-menu-item > .mega-sub-menu .mega-menu-link', function() {
      const href = $(this).attr('href');
        if (href != '') {
        document.location.href = href;
      }
    }); */
  });
})(jQuery);
(function ($) {
  'use strict';

  var modalInterval;
  var formInterval;
  $(window).on('elementor/frontend/init', function () {
    $('body').on('click', '.cf-landing-navigation .elementor-menu-toggle', onMobileMenuIconClick);
    $('body').on('click', '.cf-landing-navigation .menu-item a', onMobileMenuItemClick);
    $('body').on('click', '.cf-landing-general-btn', onGeneralBtnClick);
    $('body').on('click', '.cf-general-request-btn', onGeneralBtnClick);
    $('body').on('click', '.cf-landing-program-btn', onProgramBtnClick);
    $('body').on('click', '.cf-request-btn', onProgramBtnClick);

    // Check programs on CRM Lead Form for Landing Pages.
    onGeneralBtnClick();
  });
  function onMobileMenuIconClick(e) {
    e.preventDefault();
    e.stopPropagation();
    $('body').toggleClass('mobile-open');
  }
  function onMobileMenuItemClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var $el = $(e.currentTarget);
    var programsGroupId = $el.attr('data-programs-group-id');
    if (typeof programsGroupId === 'undefined') {
      programsGroupId = $el.parents('.elementor-tab-content').first().data('programs-group-id');
    }
    var programCode = $el.attr('data-program-code');

    // If the clicked item is a programs group item.
    if (programsGroupId) {
      var $tabMenuItem = $('body').find(".cf-programs-groups-tab-menu .cf-title[data-programs-group-id=\"".concat(programsGroupId, "\"]"));
      if ($tabMenuItem.length > 0) {
        $tabMenuItem.trigger('click');

        // Scroll to anchor.
        setTimeout(function () {
          $('html, body').animate({
            scrollTop: $($el.attr('href')).offset().top - 10
          }, 500);
        }, 350);
      }
    } else if (programCode) {
      var $programItem = $('body').find(".cf-programs-groups-tab-menu [data-program-code=\"".concat(programCode, "\"]"));
      if ($programItem.length === 0) {
        $programItem = $('body').find(".cf-programs-group-elementor-widget [data-program-code=\"".concat(programCode, "\"]"));
      }
      if ($programItem.length > 0) {
        $programItem.trigger('click');
      }
    }
    $('body').find('.elementor-menu-toggle').trigger('click');
  }
  function onGeneralBtnClick(e) {
    var programsCode = [];

    // Find all Programs that should be displayed in the modal and get their codes.
    $('body').find('.cf-programs-group-elementor-widget .cf-program-details').each(function (i, item) {
      var code = $(item).attr('data-program-code');
      if (code && programsCode.indexOf(code) == -1) {
        programsCode.push(code);
      }
    });

    // Add programs from Program Cards widget
    $('body').find('.ap-program-cards-elementor-widget .add-to-form').each(function (i, item) {
      var code = $(item).attr('data-program-code');
      if (code && programsCode.indexOf(code) == -1) {
        programsCode.push(code);
      }
    });

    // If no program was found added through cf-programs-group-elementor widget, try to check `programPageCode variable.
    if (programsCode.length === 0) {
      var currentProgramCode = window.pageProgramCode || null;
      if (currentProgramCode) {
        programsCode = [currentProgramCode];
        checkProgramsOnPopup(programsCode, currentProgramCode);
        checkProgramsOnLandingPage(programsCode, currentProgramCode);
      }
    } else {
      checkProgramsOnPopup(programsCode);
      checkProgramsOnLandingPage(programsCode);
    }
  }
  function onProgramBtnClick(e) {
    var $btn = $(e.currentTarget);
    var currentProgramCode = $btn.attr('data-program-code') || '';
    var programsCode = [];

    // Find all Programs that should be displayed in the modal and get their codes.
    $('body').find('.cf-programs-group-elementor-widget .cf-program-details').each(function (i, item) {
      var code = $(item).attr('data-program-code');
      if (code && programsCode.indexOf(code) == -1) {
        programsCode.push(code);
      }
    });

    // If no program was found added through cf-programs-group-elementor widget, try to check `programPageCode var.
    if (programsCode.length === 0) {
      if (currentProgramCode === '') {
        currentProgramCode = window.pageProgramCode || null;
      }
      programsCode = [currentProgramCode];
    }
    checkProgramsOnPopup(programsCode, currentProgramCode);
  }
  function checkProgramsOnPopup(programsCode) {
    var currentProgramCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var $modal = $('body').find('.elementor-popup-modal');
    var $popupForm = $modal.find('.cf-popup-form');
    var $programsList = $popupForm.find('.cf-programs-list select');
    var time = 50;

    // Check to see if the modal's content is loaded.
    if ($popupForm.length) {
      if ($programsList.length) {
        time = 0;
      }
    }

    // Wait until the modal's content is full loaded.
    clearInterval(modalInterval);
    modalInterval = setInterval(function () {
      if (time !== 0) {
        $modal = $('body').find('.elementor-popup-modal');
        $popupForm = $modal.find('.cf-popup-form');
        $programsList = $popupForm.find('.cf-programs-list select');
      }
      if ($popupForm.length) {
        if ($programsList.length) {
          clearInterval(modalInterval);

          // Go through all the Program Options and check to see if the program must be removed from the list, or not.
          $programsList.find('option').each(function (i, option) {
            var $option = $(option);
            var code = $option.val();
            if (programsCode.indexOf(code) === -1) {
              // Keep the Placeholder option if there are more then 2 items in the list.
              if (code === '' && programsCode.length > 1) {
                return;
              }
              var $optgroup = $option.parent();

              // Check to see if also the 'optgroup' option must be removed.
              if ($optgroup.prop('tagName').toLowerCase() === 'optgroup' && $optgroup.children().length === 1) {
                $option.remove();
                $optgroup.remove();
              } else {
                $option.remove();
              }
            }
          });

          // If a specific Program should be already selected.
          if (currentProgramCode) {
            $programsList.find("option[value='" + currentProgramCode + "']").attr('selected', 'selected');
          }
        }
      }
    }, time);
  }
  function checkProgramsOnLandingPage(programsCode) {
    var currentProgramCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var $landingPageForm = $('body').find('.cf-landing-section .cf-lead-form');
    var $programsList = $landingPageForm.find('.gfield_ap_crm_program select');
    if ($landingPageForm.length) {
      if ($programsList.length) {
        // Go through all the Program Options and check to see if the program must be removed from the list, or not.
        $programsList.find('option').each(function (i, option) {
          var $option = $(option);
          var code = $option.val();
          if (programsCode.indexOf(code) === -1) {
            // Keep the Placeholder option if there are more then 2 items in the list.
            if (code === '' && programsCode.length > 1) {
              return;
            }
            var $optgroup = $option.parent();

            // Check to see if also the 'optgroup' option must be removed.
            if ($optgroup.prop('tagName').toLowerCase() === 'optgroup' && $optgroup.children().length === 1) {
              $option.remove();
              $optgroup.remove();
            } else {
              $option.remove();
            }
          }
        });

        // If a specific Program should be already selected.
        if (currentProgramCode) {
          $programsList.find("option[value='" + currentProgramCode + "']").attr('selected', 'selected');
        }
      }
    }
  }
  $(document).on("gform_post_render", function (e) {
    onGeneralBtnClick(e);
  });
})(jQuery);
(function ($) {
  'use strict';

  var setOffset;
  window.addEventListener('load', function () {
    var headerHeight = $('.header-main').height();
    var getDifference = 0;
    //fgcu is less than 100
    if (headerHeight < 100) {
      getDifference = 100 - headerHeight;
      setOffset = 120;
      //longwood and bgsu are 100
    } else if (headerHeight == 100) {
      setOffset = 100;
      //st cloud 110
    } else if (headerHeight > 100 && headerHeight < 111) {
      setOffset = 120;
      //worcester is 118
    } else if (headerHeight > 111 && headerHeight < 120) {
      getDifference = 100 - headerHeight;
      setOffset = 110;
      //radford 140.5
    } else if (headerHeight == 120) {
      getDifference = 100 - headerHeight;
      setOffset = 300;
      //tamiu 140.26
    } else if (headerHeight == 140) {
      getDifference = 100 - headerHeight;
      setOffset = 300;
    } else if (headerHeight > 120 && headerHeight < 175) {
      getDifference = 100 - headerHeight;
      setOffset = 300;
    }
    console.log(headerHeight + ' ' + setOffset);
  });

  //jQuery(window).on('load',function(){

  // An array for each sticky menu anchor.
  var menus = [];

  // An interval used when the page is scrolled.
  var scroller;
  function getOffsetTop() {
    var $sticky = $('.elementor-top-section.elementor-sticky');
    var $anchors = $('.elementor-widget-cf-menu-anchor');
    var $adminBar = $('#wpadminbar');
    var isMobile = $('body').attr('data-elementor-device-mode') === 'mobile';
    var offset = $anchors.outerHeight();
    if ($sticky.length > 0 && !isMobile) {
      offset += $sticky.outerHeight();
    }
    if ($adminBar.length > 0) {
      offset += $adminBar.outerHeight();
    }
    return offset;
  }
  function scrollTo(anchorId) {
    var $target = $("#".concat(anchorId));
    var offset = getOffsetTop();
    var total = $target.offset().top - offset - 3; // Fine tuning.

    $('html, body').animate({
      scrollTop: total
    }, 500);
  }
  function init($el) {
    var anchors = [];
    setTimeout(function () {
      var url = window.location.hash;
      var idx = url.indexOf('#');
      var hash = idx != -1 ? url.substring(idx + 1) : '';
      // If hash is present in URL, scroll to target.
      if (hash) {
        scrollTo(hash);
      }
    }, 100);

    // Extract the anchor names from the menu elements.
    $el.find('li.cf-item a').each(function (i, item) {
      var anchorId;
      var $item = $(item);

      // Check if the anchor element exists.
      if ($item.attr('href') && $item.attr('href') !== '') {
        anchorId = $item.attr('href').replace('#', '');
        var $anchor = $("#".concat(anchorId));
        anchors.push($anchor.length ? $anchor.get(0) : null);
        $item.on('click', function () {
          scrollTo(anchorId);
          return false;
        });
      }
    });
    menus.push({
      $el: $el,
      anchors: anchors
    });
    $(window).scroll(function () {
      onScroll();
    });
  }
  function onScroll() {
    var scrollTop = $(window).scrollTop();
    var $anchorsMenu = $('.elementor-widget-cf-menu-anchor');
    var anchorsMenuHeight = $anchorsMenu.length > 0 ? $anchorsMenu.outerHeight() : 0;
    clearInterval(scroller);
    scroller = setInterval(function () {
      clearInterval(scroller);

      // Check every sticky menu anchor from the page.
      $.each(menus, function (i, menu) {
        var $el = menu.$el;
        var anchors = menu.anchors;

        //console.log('anchors: ' + anchors);
        //const menuTopPos = $el.css('position') !== 'fixed' ? $el.offset().top : parseFloat($el.css('top'));

        var menuTopPos = parseFloat($el.css('top'));

        //console.log('menuTopPos: ' + menuTopPos);

        // Verify what is the current active element by checking anchors positions relative to the menu and the window scroll.
        var selectedAnchorIndex = 0;
        $.each(anchors, function (index, anchor) {
          //console.log('anchor: ' + anchor);
          //console.log('anchorsMenuHeight: ' + anchorsMenuHeight);
          if (anchor) {
            var anchorTopPos = $(anchor).offset().top - scrollTop - anchorsMenuHeight - setOffset; // Fine tuning
            //console.log('anchorTopPos: ' + anchorTopPos);
            //console.log('scrollTop: ' + scrollTop);
            //console.log('setOffset: ' + setOffset);
            if (anchorTopPos <= menuTopPos) {
              selectedAnchorIndex = index;
              //console.log('selectedAnchorIndex: ' + selectedAnchorIndex);
            }
          }
        });

        // Activate the element.
        $el.find('li.cf-item').removeClass('active');
        $el.find("li.cf-item:eq(".concat(selectedAnchorIndex, ")")).addClass('active');
        //console.log($el.find(`li.cf-item:eq(${selectedAnchorIndex})`));
      });
    }, 100);
  }

  // Elementor JS Hooks.
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cf-menu-anchor.default', init);
  });
})(jQuery);
(function ($) {
  'use strict';

  //hide all levels 
  $(document).ready(function () {
    $('html, body').animate({
      scrollTop: 0
    });
    $('.areas').hide();
    $('.plp-form').hide();
    $(".program-select option:selected").removeAttr("selected");
    $('.plp-refresh').hide();
  });
  $(document).on('click', '.plp-refresh', function (e) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    });
    $('.areas').hide();
    $('.plp-form').hide();
    $('.plp-refresh').hide();
    $('.button').removeClass('active');
    $(".program-select option:selected").removeAttr("selected");
  });
  $(document).on('click', '.program-level', function (e) {
    event.preventDefault();
    $('.plp-refresh').show();
    $('.areas').hide();
    $('.plp-form').hide();
    $('.program-level').removeClass('active');
    $(this).addClass('active');
    var mainelement = $(this).attr('id');
    $('#program_of_interest_' + mainelement).show();
    $('html, body').animate({
      scrollTop: $('#program_of_interest_' + mainelement).offset().top
    }, "800");
    $(".program-select option:selected").removeAttr("selected");
  });
  $(document).on('click', '.area-of-interest', function (e) {
    event.preventDefault();
    $('.plp-form').hide();
    $('.actual-program').hide();
    $('.area-of-interest').removeClass('active');
    $(this).addClass('active');
    var mainelement = $(this).attr('id');
    $('#actual_program_' + mainelement).show();
    $('html, body').animate({
      scrollTop: $('#actual_program_' + mainelement).offset().top
    }, "800");
  });
  $(document).on('change', '.program-select', function (e) {
    var optionvalue = $(this).find("option:selected").val();
    var optiontext = $(this).find("option:selected").text();
    var optionshow = 'option[value=\'' + optionvalue + '\']';
    $('.plp-form').show();
    $('html, body').animate({
      scrollTop: $('.plp-form').offset().top
    }, "800");
    $('span.program-name').text(' ' + optiontext);
    $('.gfield_ap_crm_program select').val(optionvalue);
    $('.gfield_ap_crm_program').hide();
  });
})(jQuery);
(function ($) {
  'use strict';

  $(document).ready(function () {
    $('.scrolling_inner').addClass('scroll-right');
    // show gradient in table when scrolling occurs
    $('.cf-program-calendar-table-widget').on('scroll', function () {
      var parent_div = $(this).parent();
      if ($(this).scrollLeft() + $(this).innerWidth() >= $(this)[0].scrollWidth) {
        if (parent_div.hasClass('scroll-right')) {
          parent_div.removeClass('scroll-right');
        }
      } else if ($(this).scrollLeft() === 0) {
        if (parent_div.hasClass('scroll-left')) {
          parent_div.removeClass('scroll-left');
        }
      } else {
        if (!parent_div.hasClass('scroll-right')) {
          parent_div.addClass('scroll-right');
        }
        if (!parent_div.hasClass('scroll-left')) {
          parent_div.addClass('scroll-left');
        }
      }
    });

    // determine if gradients are needed on page load
    var scrolling_tables = document.getElementsByClassName('cf-program-calendar-table-widget');
    for (var i = 0; i < scrolling_tables.length; i++) {
      var scrolling_div = scrolling_tables[i];
      if (scrolling_div.offsetWidth < scrolling_div.scrollWidth) {
        if (!$('.scrolling_inner').hasClass('scroll-right')) {
          $('.scrolling_inner').addClass('scroll-right');
        }
      }
    }
  });

  // show / hide the gradient on scrolling table
  function scrolling_table_shadows() {
    var be_compare_container = document.getElementById('be_compare_features_table');
    if (be_compare_container === null) return;
    if (be_compare_container.offsetWidth < be_compare_container.scrollWidth) {
      if (!$('#be_compare_features_table_inner').hasClass('scroll-right')) {
        $('#be_compare_features_table_inner').addClass('scroll-right');
      }
    } else {
      if ($('#be_compare_features_table_inner').hasClass('scroll-right')) {
        $('#be_compare_features_table_inner').removeClass('scroll-right');
      }
      if ($('#be_compare_features_table_inner').hasClass('scroll-left')) {
        $('#be_compare_features_table_inner').removeClass('scroll-left');
      }
    }
  }

  // evaluate gradients when the window is resized
  $(window).on('resize', function () {
    scrolling_table_shadows();
  });
})(jQuery);
jQuery(document).on('click', '.custom-accordion .accordion-header', function () {
  var accordtion_title = jQuery(this);
  var accordion_item = jQuery('.accordion-content');

  // Check if the clicked program content is already active

  if (accordtion_title.hasClass('active')) {
    accordtion_title.removeClass('active');
    accordtion_title.next().slideUp();
  } else {
    accordion_item.slideUp();
    accordion_item.prev().removeClass('active');
    accordtion_title.next().slideDown();
    accordtion_title.addClass('active');
  }
  return false;
});
(function ($) {
  'use strict';

  $(window).on('elementor/frontend/init', function () {
    $('.cf-js-programs-list').on('change', function () {
      var url = $(this).find(':selected').data('url');
      if (url) {
        window.location.href = url;
      }
    });
  });
})(jQuery);
(function ($) {
  'use strict';

  $(window).on('elementor/frontend/init', function () {
    var interval = setInterval(function () {
      if (elementorFrontend.elementsHandler) {
        clearInterval(interval);

        // Get default toggle widget handlers.
        var toggleHandler = elementorFrontend.elementsHandler.getHandler('toggle.default');

        // Register handlers for custom widget.
        elementorFrontend.hooks.addAction('frontend/element_ready/cf-programs-accordion.default', toggleHandler);
      }
    }, 50);
  });
})(jQuery);
(function ($) {
  'use strict';

  $(window).on('elementor/frontend/init', function () {
    $('body').on('click', '.cf-programs-groups-tab-menu .cf-item a.cf-title', onMenuItemClick);

    // Add programs from 'programs groups widgets' to the menu tab's content.
    addProgramsToAccordion();

    // Check and see if the tabs items must be added in a mobile menu.
    checkMobileMenu();
  });
  function addProgramsToAccordion() {
    var itemsTitle = $('body').find('.cf-programs-groups-tab-menu .cf-item .cf-title');
    var itemsContent = $('body').find('.cf-programs-groups-tab-menu .cf-item .cf-content');
    $.each(itemsTitle, function (i, item) {
      var programsGroupId = $(item).attr('data-programs-group-id');
      var $itemContent = $(itemsContent[i]);
      var isActive = $(item).hasClass('elementor-active');

      // Wait for the Accordion Widget to finish render, and activate the item if needed.
      // (At runtime, by default, the Accordion Widget is closing all items if it sees some of them opened).
      if (isActive) {
        setTimeout(function () {
          $(item).addClass('elementor-active');
          $itemContent.addClass('elementor-active');
          $itemContent.show();
        }, 50);
      }

      // For each tab find the coresponding programs group, get the content and add it into the tab's content element.
      // This is an option working only for mobile, where the tab menu is acting like an accordion.
      if (programsGroupId !== '') {
        var programsGroup = $('body').find(".cf-programs-group-elementor-widget[data-programs-group-id=\"".concat(programsGroupId, "\"]"));
        var html = $itemContent.html();

        // In case if there are multiple programs groups with the same id, copy the content from all of them.
        $.each(programsGroup, function (j, group) {
          html += $(group).html();
        });
        $itemContent.html(html);

        // Remove the css class from the new content copied to avoid bad functionality from the accordion.
        $itemContent.find('.elementor-tab-title').removeClass('elementor-tab-title');
      }
    });
  }
  function onMenuItemClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var $menuItem = $(e.currentTarget);
    var programsGroupId = $menuItem.attr('data-programs-group-id');
    if (typeof programsGroupId === 'undefined') {
      programsGroupId = $menuItem.parents('.elementor-tab-content').first().data('programs-group-id');
    }
    var $programsGroups = $('body').find('.cf-programs-group-elementor-widget');
    var $selectedProgramsGroup = $('body').find(".cf-programs-group-elementor-widget[data-programs-group-id=\"".concat(programsGroupId, "\"]"));
    var isMobile = $('body').attr('data-elementor-device-mode') === 'mobile';
    $programsGroups.hide();
    $selectedProgramsGroup.show();

    // If there is a programs group selected, check to see if any of the program items is already active.
    if ($selectedProgramsGroup.length > 0) {
      var $prevSelectedProgramFromGroup = $selectedProgramsGroup.find('.cf-title.elementor-active');

      // If a program item is already active, trigger a click event over it.
      if ($prevSelectedProgramFromGroup.length > 0) {
        if (!isMobile) {
          $prevSelectedProgramFromGroup.trigger('click');
        }
      } else {
        // If there is no program item already active, select the first one found and click it.
        var $firstProgramFromGroup = $($selectedProgramsGroup.get(0)).find('.cf-program-item:eq(0) .cf-title');
        if (!isMobile) {
          $firstProgramFromGroup.trigger('click');
        }
      }
    }
  }
  function checkMobileMenu() {
    var $tabMenu = $('body').find('.cf-programs-groups-tab-menu[data-mobile-menu-css-class]');
    $tabMenu.each(function (i, el) {
      var mobileMenuCssClass = $(el).attr('data-mobile-menu-css-class');
      if (mobileMenuCssClass != '') {
        var $mobileMenu = $('body').find(".".concat(mobileMenuCssClass));
        var showMobileMenu = false;
        if ($mobileMenu.length > 0) {
          var $mobileMenuContainer = $mobileMenu.find('.elementor-nav-menu--dropdown .elementor-nav-menu');
          var $emptyItem = $mobileMenuContainer.find('.cf-empty');
          if ($emptyItem.length > 0) {
            $(el).find('> ul > li.cf-item > .cf-title').each(function (i, item) {
              var $newMenuItem = $emptyItem.clone().removeClass('cf-empty');
              var $newTabItem = $(item).clone();
              $newTabItem.html($newTabItem.text());
              $newMenuItem.html($newTabItem[0].outerHTML);
              $newMenuItem.appendTo($mobileMenuContainer);
              showMobileMenu = true;
            });
          }
        }
        if (showMobileMenu) {
          $mobileMenu.removeClass('elementor-hidden-phone');
        }
      }
    });
  }
})(jQuery);
(function ($) {
  'use strict';

  var firstTimeProgramClick = true;
  $(window).on('elementor/frontend/init', function () {
    // Add 'click' action for all program items inside the programs groups.
    $('body').on('click', '.cf-programs-group-elementor-widget a.cf-title', onProgramClick);

    // Add 'click' action for all program items inside the tabs' content elements (mobile).
    $('body').on('click', '.cf-programs-groups-tab-menu .cf-program-item a.cf-title', onProgramClick);
    $('body').on('click', '.cf-program-details-btn-close', onProgramDetailsPopupClose);

    // Check each programs group to see if there is a relation with a tab menu.
    checkProgramsGroups();

    // Check what is the current active program and click it.
    checkActiveProgram();

    // Check and see if the program items must be added in a mobile menu.
    checkMobileMenu();
  });
  function onProgramClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var $programItem = $(e.currentTarget);
    var $programsGroup = $programItem.closest('[data-programs-group-id]');
    var programCode = $programItem.attr('data-program-code');
    var outputId = $programItem.attr('data-program-output-id');

    //firstTimeProgramClick = false;

    var programsGroupId = $programsGroup.attr('data-programs-group-id');
    if (typeof programsGroupId === 'undefined') {
      programsGroupId = $menuItem.parents('.elementor-tab-content').first().data('programs-group-id');
    }
    var $container = $programItem.closest('.cf-programs-group-elementor-widget');
    var isMobile = $('body').attr('data-elementor-device-mode') === 'mobile';
    var hasAdminBar = jQuery('body').hasClass('admin-bar');
    if ($container.length === 0) {
      $container = $programItem.closest('.cf-programs-groups-tab-menu');
    }
    var $programDetails = $container.find(".cf-program-details[data-program-code='".concat(programCode, "']"));

    // Get the Program Details html and render it in the output widget.
    var $outputContainer = $(".cf-program-details-output-widget[data-program-details-output-id='".concat(outputId, "']"));
    var $outputWrapper = $outputContainer.closest('.elementor-widget-cf-program-details-output');
    var $btnClose = $outputWrapper.siblings('.cf-program-details-btn-close');
    $outputContainer.html($programDetails.html());
    if (isMobile) {
      $outputWrapper.show();
      $outputContainer.scrollTop(0);
      $btnClose.show();
      setTimeout(function () {
        $outputWrapper.addClass('toggle-output');
      }, 100);
      $('body').addClass('mobile-open');
    }

    // Deactivate the previous program items, and activate the selected one.
    if (programsGroupId !== null && programsGroupId != '') {
      $('body').find(".cf-programs-group-elementor-widget[data-programs-group-id=".concat(programsGroupId, "] a.cf-title")).removeClass('elementor-active');
    } else {
      $('body').find(".cf-programs-group-elementor-widget[data-programs-group-id] a.cf-title").removeClass('elementor-active');
    }
    $('body').find('.cf-programs-groups-tab-menu .cf-program-item a.cf-title').removeClass('elementor-active');
    $programItem.addClass('elementor-active');

    // Scroll to anchor.
    if (!isMobile) {
      var deltaTop = 10;
      if (hasAdminBar) {
        deltaTop += $('#wpadminbar').height();
      }

      //if (!firstTimeProgramClick && $programItem.length) {
      //  $('html, body').animate({ 
      //    scrollTop: $($programItem.attr('href')).offset().top - deltaTop
      //  }, 500);
      //}

      if (!firstTimeProgramClick) {
        $('html, body').animate({
          scrollTop: $($programItem.attr('href')).offset().top - deltaTop
        }, 500);
      }
    }
  }
  function onProgramDetailsPopupClose(e) {
    e.preventDefault();
    e.stopPropagation();
    var $btnClose = $(e.currentTarget);
    var $outputWrapper = $btnClose.siblings('.elementor-widget-cf-program-details-output');
    $('body').removeClass('mobile-open');
    $outputWrapper.removeClass('toggle-output');
    $btnClose.hide();
  }
  function checkProgramsGroups() {
    var $programsGroups = $('body').find('.cf-programs-group-elementor-widget');

    // Take each programs group and try to find a coresponding tab item. If there is no one, force displaying the programs group on mobile.
    $programsGroups.each(function (i, group) {
      var programsGroupId = $(group).attr('data-programs-group-id');
      if (programsGroupId !== '') {
        var $tabMenu = $('body').find(".cf-programs-groups-tab-menu .cf-item .cf-title[data-programs-group-id='".concat(programsGroupId, "']"));
        if ($tabMenu.length === 0 && group.style.display !== 'none') {
          $(group).addClass('show-on-mobile');
        }
      }
    });
  }
  function checkActiveProgram() {
    if ($('body').attr('data-elementor-device-mode') !== 'mobile') {
      $('body').find('.cf-programs-group-elementor-widget a.cf-title.elementor-active[data-program-code]:eq(0)').trigger('click');
      firstTimeProgramClick = false;
    }
  }
  function checkMobileMenu() {
    var $programsGroup = $('body').find('.cf-programs-group-elementor-widget[data-mobile-menu-css-class]');
    $programsGroup.each(function (i, el) {
      var mobileMenuCssClass = $(el).attr('data-mobile-menu-css-class');
      if (mobileMenuCssClass != '') {
        var $mobileMenu = $('body').find(".".concat(mobileMenuCssClass));
        var showMobileMenu = false;
        if ($mobileMenu.length > 0) {
          var $mobileMenuContainer = $mobileMenu.find('.elementor-nav-menu--dropdown .elementor-nav-menu');
          var $emptyItem = $mobileMenuContainer.find('.cf-empty');
          if ($emptyItem.length > 0) {
            $(el).find('> ul.cf-programs-list > li.cf-program-item > .cf-title').each(function (i, item) {
              var $newMenuItem = $emptyItem.clone().removeClass('cf-empty');
              var $newProgramItem = $(item).clone();
              $newProgramItem.html($newProgramItem.text());
              $newMenuItem.html($newProgramItem[0].outerHTML);
              $newMenuItem.appendTo($mobileMenuContainer);
              showMobileMenu = true;
            });
          }
        }
        if (showMobileMenu) {
          $mobileMenu.removeClass('elementor-hidden-phone');
        }
      }
    });
  }
})(jQuery);

/*
 * This is an override of the Sticky plugin made by Elementor team.
 * Add relative sticky for menu anchor widgets.
 *
 * Original Path: elementor-pro/assets/js/lib/sticky/jquery.sticky.js
 *
 */

(function ($) {
  var CF_Sticky = function CF_Sticky(element, userSettings) {
    var $element = $(element),
      isSticky = false,
      isFollowingParent = false,
      isReachedEffectsPoint = false,
      elements = {},
      settings,
      relativeOffset = 0;
    var defaultSettings = {
      to: 'top',
      offset: 0,
      initialOffset: userSettings.offset ? userSettings.offset : 0,
      effectsOffset: 0,
      parent: false,
      classes: {
        sticky: 'sticky',
        stickyActive: 'sticky-active',
        stickyEffects: 'sticky-effects',
        spacer: 'sticky-spacer'
      }
    };
    var initSettings = function initSettings() {
      settings = jQuery.extend(true, defaultSettings, userSettings);
    };
    var initElements = function initElements() {
      $element = $(element).addClass(settings.classes.sticky);
      elements.$window = $(window);
      if (settings.parent) {
        if (settings.parent === 'parent') {
          elements.$parent = $element.parent();
        } else {
          elements.$parent = $element.closest(settings.parent);
        }
      }
    };
    var bindEvents = function bindEvents() {
      elements.$window.on({
        scroll: onWindowScroll,
        resize: onWindowResize
      });
    };
    var unbindEvents = function unbindEvents() {
      elements.$window.off('scroll', onWindowScroll).off('resize', onWindowResize);
    };
    var init = function init() {
      initSettings();
      resetRelativeOffset();
      initElements();
      bindEvents();
      checkPosition();
    };
    var backupCSS = function backupCSS($elementBackupCSS, backupState, properties) {
      var css = {},
        elementStyle = $elementBackupCSS[0].style;
      properties.forEach(function (property) {
        css[property] = undefined !== elementStyle[property] ? elementStyle[property] : '';
      });
      $elementBackupCSS.data('css-backup-' + backupState, css);
    };
    var getCSSBackup = function getCSSBackup($elementCSSBackup, backupState) {
      return $elementCSSBackup.data('css-backup-' + backupState);
    };
    var addSpacer = function addSpacer() {
      elements.$spacer = $element.clone().addClass(settings.classes.spacer).css({
        visibility: 'hidden',
        transition: 'none',
        animation: 'none'
      });
      $element.after(elements.$spacer);
    };
    var removeSpacer = function removeSpacer() {
      elements.$spacer.remove();
    };
    var stickElement = function stickElement() {
      backupCSS($element, 'unsticky', ['position', 'width', 'margin-top', 'margin-bottom', 'top', 'bottom']);
      var css = {
        position: 'fixed',
        width: getElementOuterSize($element, 'width'),
        marginTop: 0,
        marginBottom: 0
      };
      css[settings.to] = settings.offset;
      css[settings.to === 'top' ? 'bottom' : 'top'] = '';
      $element.css(css).addClass(settings.classes.stickyActive);
    };
    var unstickElement = function unstickElement() {
      $element.css(getCSSBackup($element, 'unsticky')).removeClass(settings.classes.stickyActive);
    };
    var followParent = function followParent() {
      backupCSS(elements.$parent, 'childNotFollowing', ['position']);
      elements.$parent.css('position', 'relative');
      backupCSS($element, 'notFollowing', ['position', 'top', 'bottom']);
      var css = {
        position: 'absolute'
      };
      css[settings.to] = '';
      css['top' === settings.to ? 'bottom' : 'top'] = 0;
      $element.css(css);
      isFollowingParent = true;
    };
    var unfollowParent = function unfollowParent() {
      elements.$parent.css(getCSSBackup(elements.$parent, 'childNotFollowing'));
      $element.css(getCSSBackup($element, 'notFollowing'));
      isFollowingParent = false;
    };
    var getElementOuterSize = function getElementOuterSize($elementOuterSize, dimension, includeMargins) {
      var computedStyle = getComputedStyle($elementOuterSize[0]),
        elementSize = parseFloat(computedStyle[dimension]),
        sides = dimension === 'height' ? ['top', 'bottom'] : ['left', 'right'],
        propertiesToAdd = [];
      if ('border-box' !== computedStyle.boxSizing) {
        propertiesToAdd.push('border', 'padding');
      }
      if (includeMargins) {
        propertiesToAdd.push('margin');
      }
      propertiesToAdd.forEach(function (property) {
        sides.forEach(function (side) {
          elementSize += parseFloat(computedStyle[property + '-' + side]);
        });
      });
      return elementSize;
    };
    var getElementViewportOffset = function getElementViewportOffset($elementViewportOffset) {
      var windowScrollTop = elements.$window.scrollTop(),
        elementHeight = getElementOuterSize($elementViewportOffset, 'height'),
        viewportHeight = innerHeight,
        elementOffsetFromTop = $elementViewportOffset.offset().top,
        distanceFromTop = elementOffsetFromTop - windowScrollTop,
        topFromBottom = distanceFromTop - viewportHeight;
      return {
        top: {
          fromTop: distanceFromTop,
          fromBottom: topFromBottom
        },
        bottom: {
          fromTop: distanceFromTop + elementHeight,
          fromBottom: topFromBottom + elementHeight
        }
      };
    };
    var stick = function stick() {
      addSpacer();
      stickElement();
      isSticky = true;
      $element.trigger('sticky:stick');
    };
    var unstick = function unstick() {
      unstickElement();
      removeSpacer();
      isSticky = false;
      $element.trigger('sticky:unstick');
    };
    var checkParent = function checkParent() {
      var elementOffset = getElementViewportOffset($element),
        isTop = settings.to === 'top';
      if (isFollowingParent) {
        var isNeedUnfollowing = isTop ? elementOffset.top.fromTop > settings.offset : elementOffset.bottom.fromBottom < -settings.offset;
        if (isNeedUnfollowing) {
          unfollowParent();
        }
      } else {
        var parentOffset = getElementViewportOffset(elements.$parent),
          parentStyle = getComputedStyle(elements.$parent[0]),
          borderWidthToDecrease = parseFloat(parentStyle[isTop ? 'borderBottomWidth' : 'borderTopWidth']),
          parentViewportDistance = isTop ? parentOffset.bottom.fromTop - borderWidthToDecrease : parentOffset.top.fromBottom + borderWidthToDecrease,
          isNeedFollowing = isTop ? parentViewportDistance <= elementOffset.bottom.fromTop : parentViewportDistance >= elementOffset.top.fromBottom;
        if (isNeedFollowing) {
          followParent();
        }
      }
    };
    var checkEffectsPoint = function checkEffectsPoint(distanceFromTriggerPoint) {
      if (isReachedEffectsPoint && -distanceFromTriggerPoint < settings.effectsOffset) {
        $element.removeClass(settings.classes.stickyEffects);
        isReachedEffectsPoint = false;
      } else if (!isReachedEffectsPoint && -distanceFromTriggerPoint >= settings.effectsOffset) {
        $element.addClass(settings.classes.stickyEffects);
        isReachedEffectsPoint = true;
      }
    };
    var checkPosition = function checkPosition() {
      var offset = settings.offset,
        distanceFromTriggerPoint;
      if (isSticky) {
        var spacerViewportOffset = getElementViewportOffset(elements.$spacer);
        distanceFromTriggerPoint = settings.to === 'top' ? spacerViewportOffset.top.fromTop - offset : -spacerViewportOffset.bottom.fromBottom - offset;
        if (settings.parent) {
          checkParent();
        }
        if (distanceFromTriggerPoint > 0) {
          unstick();
        }
      } else {
        var elementViewportOffset = getElementViewportOffset($element);
        distanceFromTriggerPoint = settings.to === 'top' ? elementViewportOffset.top.fromTop - offset : -elementViewportOffset.bottom.fromBottom - offset;
        if (distanceFromTriggerPoint <= 0) {
          stick();
          if (settings.parent) {
            checkParent();
          }
        }
      }
      checkEffectsPoint(distanceFromTriggerPoint);
    };
    var onWindowScroll = function onWindowScroll() {
      checkPosition();
    };
    var onWindowResize = function onWindowResize() {
      if (!isSticky) {
        return;
      }
      unstickElement();
      resetRelativeOffset();
      stickElement();
    };
    var resetRelativeOffset = function resetRelativeOffset() {
      if ($element.attr('data-sticky-relative') !== null && $element.attr('data-settings')) {
        var _relativeOffset = settings.initialOffset;
        $('.elementor-sticky').filter(function () {
          var data = JSON.parse($element.attr('data-settings'));
          // Return only the elements that are sticky to the top and are above the current menu element.
          if (data && data !== '' && data.sticky && data.sticky === 'top') {
            if ($(this).css("position") !== "fixed" && $(this).data('id') !== $element.data('id') && $(this).offset().top <= $element.offset().top) {
              _relativeOffset += $(this).height();
            }
          }
        });
        settings.offset = _relativeOffset;
      }
    };
    this.destroy = function () {
      if (isSticky) {
        unstick();
      }
      unbindEvents();
      $element.removeClass(settings.classes.sticky);
    };
    init();
  };
  window.CF_Sticky = CF_Sticky;
  $(document).ready(function () {
    $.fn.sticky = function (settings) {
      var isCommand = typeof settings === 'string';
      this.each(function () {
        var $this = $(this);
        if (!isCommand) {
          $this.data('sticky', new CF_Sticky(this, settings));
          return;
        }
        var instance = $this.data('sticky');
        if (!instance) {
          throw Error('Trying to perform the `' + settings + '` method prior to initialization');
        }
        if (!instance[settings]) {
          throw ReferenceError('Method `' + settings + '` not found in sticky instance');
        }
        instance[settings].apply(instance, Array.prototype.slice.call(arguments, 1));
        if (settings === 'destroy') {
          $this.removeData('sticky');
        }
      });
      return this;
    };
  });
})(jQuery);
(function ($) {
  'use strict';

  var widget_type = ['cf-value-props', 'ap-value-props'];
  var settings;
  var $el;
  $(window).on('elementor/frontend/init', function () {
    if (window.elementor) {
      elementor.hooks.addAction('panel/open_editor/widget', function (panel, model, view) {
        if (widget_type.includes(model.attributes.widgetType)) {
          settings = view.getEditModel().get('settings');
          $el = panel.$el;
          $el.off('change', 'input[data-setting="cf_value_props_same_template"]', onInputChange);
          $el.on('change', 'input[data-setting="cf_value_props_same_template"]', onInputChange);
          $el.off('click', '.elementor-control-cf_value_props_list .elementor-repeater-add', onAddItemClick);
          $el.on('click', '.elementor-control-cf_value_props_list .elementor-repeater-add', onAddItemClick);
        }
      });
    }
  });
  function onInputChange(e) {
    var isChecked = $(e.currentTarget).is(':checked');
    checkRepeaterItems(isChecked);
  }
  function onAddItemClick(e) {
    var isChecked = $el.find('input[data-setting="cf_value_props_same_template"]').is(':checked');
    checkRepeaterItems(isChecked);
  }
  function checkRepeaterItems(isChecked) {
    var control = settings.controls.cf_value_props_list;

    // Find the 'item_name' Model and update its value.
    $.each(settings.attributes.cf_value_props_list.models, function (i, model) {
      model.set('use_global_template', isChecked ? 'yes' : 'no');
    });
  }
})(jQuery);
(function ($) {
  'use strict';

  $(document).ready(function () {
    if (window.elementor) {
      elementor.conditions.compare = elementorConditionsCompare;
    }
  });

  /**
   * Override the compare function from Elementor Conditions Class and
   * add a new compare type named 'collection'. This will search into
   * all models instances received on 'leftValue' and check if all conditions
   * from 'rightValue' array are checked.
   *
   * Ex for 'rightValue' array:
   * [
   *   [
   *     'attr_property' => 'property1',
   *     'operator'      => '==',
   *     'attr_value'    => 'value1',
   *   ],
   *   [
   *     'attr_property' => 'property2',
   *     'operator'      => '!=',
   *     'attr_value'    => 'value2',
   *   ]
   * ]
   *
   * @return boolean
   */
  function elementorConditionsCompare(leftValue, rightValue, operator) {
    switch (operator) {
      case '==':
        return leftValue == rightValue;
      case '!=':
        return leftValue != rightValue;
      case '!==':
        return leftValue !== rightValue;
      case 'in':
        return -1 !== rightValue.indexOf(leftValue);
      case '!in':
        return -1 === rightValue.indexOf(leftValue);
      case 'contains':
        return -1 !== leftValue.indexOf(rightValue);
      case '!contains':
        return -1 === leftValue.indexOf(rightValue);
      case '<':
        return leftValue < rightValue;
      case '<=':
        return leftValue <= rightValue;
      case '>':
        return leftValue > rightValue;
      case '>=':
        return leftValue >= rightValue;
      case 'collection':
        if (leftValue.models && leftValue.models.length > 0) {
          var valid = false;

          // Pass through all models intances and check all conditions.
          $.each(leftValue.models, function (index, model) {
            if (model.attributes) {
              var isTrue = true;

              // Check if all conditions pass validation
              $.each(rightValue, function (j, condition) {
                var attrProperty = condition['attr_property'];
                var attrValue = condition['attr_value'];
                var conditionOperator = condition['operator'];
                if (model.attributes[attrProperty] && elementorConditionsCompare(model.attributes[attrProperty], attrValue, conditionOperator) && isTrue) {
                  isTrue = true;
                } else {
                  isTrue = false;
                }
              });
              if (isTrue) {
                valid = true;
              }
            }
          });
          return valid;
        }
        return false;
      default:
        return leftValue === rightValue;
    }
  }
})(jQuery);
(function ($) {
  'use strict';

  //hide all levels 
  $(document).ready(function () {
    $('.areas').hide();
    $('.plp-form').hide();
    $(".rp-program-select option:selected").removeAttr("selected");
    multiStep();
    addUrlSelectedProgramValue();
  });
  $(document).on('click', '.rp-refresh-btn', function (e) {
    window.scrollTo(0, 0); // scroll to top first
    location.reload(); // then reload
  });
  $(document).on('change', '.stepplp .rp-program-level', function (e) {
    e.preventDefault();
    $('.areas').hide();
    $('.plp-form').hide();
    $('.rp-program-level').removeClass('active');
    $(this).addClass('active');
    var mainelement = $(this).attr('id');
    $('#program_of_interest_' + mainelement).show();
    $(".rp-program-select option:selected").removeAttr("selected");
  });
  $(document).on('change', '.rp-area-of-interest', function (e) {
    e.preventDefault();
    $('.plp-form').hide();
    $('.actual-program').hide();
    $('.rp-area-of-interest').removeClass('active');
    $(this).addClass('active');
    var mainelement = $(this).attr('id');
    $('#actual_program_' + mainelement).show();
  });
  $(document).on('change', '.rp-program-select', function (e) {
    var optionvalue = $(this).find("option:selected").val();
    var optiontext = $(this).find("option:selected").text();
    var optionshow = 'option[value=\'' + optionvalue + '\']';
    $('.plp-form').show();
    $('span.program-name').text(' ' + optiontext);
    $('.gfield_ap_crm_program select').val(optionvalue);
    $('.gfield_ap_crm_program').hide();
  });
  function addUrlSelectedProgramValue() {
    $('#step-3 .complete-info').hide();
    // Whenever any rp-program-select changes...
    $('.rp-program-select').on('change', function () {
      var code = $(this).val();
      if (code) {
        $('#step-3 .plp-nav').hide();
        $('#step-3 .complete-info').show();
      } else {
        $('#step-3 .plp-nav').show();
        $('#step-3 .complete-info').hide();
      }
      // Find the .rp-program-details wrapper in the same program area
      var $details = $(this).closest('.areas').find('.rp-program-detail');

      // Hide all, then show the one matching data-code
      $details.hide().filter('[data-code="' + code + '"]').show();
    });
  }

  // added function multistep..
  function multiStep() {
    //  Collections all the way
    var $steps = $('.cf-plp-elementor-widget .stepplp'); // jQuery collection

    var currentStep = 0;

    // Helper
    function showStep(idx) {
      if (idx < 0 || idx >= $steps.length) return;
      $steps.eq(currentStep).removeClass('plpactive');
      currentStep = idx;
      $steps.eq(currentStep).addClass('plpactive');
    }

    // Listeners
    $steps.each(function (idx, step) {
      // next‑step buttons
      $(step).on('click', 'input[type="radio"]:not([data-back])', function () {
        if (idx < $steps.length - 1) showStep(idx + 1);
      });

      // back button
      $(step).on('click', 'button.btn-back', function (e) {
        e.stopPropagation();
        showStep(idx - 1);
      });
    });
  }
})(jQuery);